/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
export interface PasswordRules {
    minimumLength: number;
    required: boolean;
    requireCapitalLetters: boolean;
    requireNumbers: boolean;
    requireSmallLetters: boolean;
    requireSpecialCharacters: boolean;
    minimumTypesRequired?: number;
}

const supportedSpecialCharacters = [
    ' ',
    '!',
    '"',
    '#',
    '$',
    '%',
    '&',
    "'",
    '(',
    ')',
    '*',
    '+',
    ',',
    '-',
    '.',
    '/',
    ':',
    ';',
    '<',
    '=',
    '>',
    '?',
    '@',
    '[',
    '\\',
    ']',
    '^',
    '_',
    '`',
    '{',
    '|',
    '}',
    '~',
];

export const UpperCaseRegex = /[A-Z]/;
export const NumberRegex = /[0-9]/;
export const SpecialCharacterRegex = new RegExp(
    supportedSpecialCharacters
        .map((char) =>
            [
                '\\',
                '.',
                '*',
                '+',
                '?',
                '^',
                '$',
                '(',
                ')',
                '[',
                ']',
                '{',
                '}',
                '|',
            ].includes(char)
                ? `\\${char}`
                : char
        )
        .join('|')
);

export const validatePassword = (password: string, rules: PasswordRules) => {
    const errors: string[] = [];

    if (password.length < rules.minimumLength) {
        errors.push(
            `Password must be at least ${rules.minimumLength} characters`
        );
    }

    const typesPresent = [
        rules.requireCapitalLetters && UpperCaseRegex.test(password),
        rules.requireNumbers && NumberRegex.test(password),
        rules.requireSmallLetters && /[a-z]/.test(password),
        rules.requireSpecialCharacters && SpecialCharacterRegex.test(password),
    ].filter(Boolean).length;

    const minimumRequired = rules.minimumTypesRequired || 4;

    if (typesPresent < minimumRequired) {
        errors.push(
            `Password must contain at least ${minimumRequired} of the following: lowercase letter, uppercase letter, number, special character`
        );
    }

    return errors;
};
